<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 10px;">
			<el-button @click="handleAdd">添加新用户</el-button>
			<el-button @click="handleBatchImport">批量导入</el-button>
			<el-button @click="exportData">数据导出</el-button>
			<el-input style="width: 30%;float:right;" placeholder="请输入中英文名称或项目名称" v-model="search_word">
				<el-button slot="append" icon="search" @click="handleSearch"></el-button>
			</el-input>
		</el-col>
		<el-dialog title="批量导入用户" v-model="batchImportDialogVisible" @close="cancelUpload">
			<el-upload :limit="1"  :on-exceed="handleUploadExceed" :action="uploadUrl"  :on-success="handleUploadSuccess" :on-error="handleUploadError"  :before-upload ="handleBeforeUpload" :headers="uploadHeader" ref="batchImportUpload" :auto-upload="false">
				<span>选取文件:&nbsp;&nbsp;&nbsp;&nbsp;</span><el-button size="small" type="primary">请选择</el-button>
				<a style="display:inline;padding-left:350px;color:#b0b1b3;text-decoration:underline;" v-on:click.stop.prevent="downloadTemplate">模版下载</a>
				<div slot="tip" style="margin-top:55px;" class="el-upload__tip">温馨提示:只能上传excel文件，且不超过20MB</div>
			</el-upload>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelUpload">取 消</el-button>
				<el-button type="primary" @click="batchImportOnSubmit">确 定</el-button>
			</div>
        </el-dialog>

		<!--列表-->
		<el-table :data="list_data" size="mini" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="index" width="50">
			</el-table-column>
			<el-table-column prop="userNameCn" label="中文名称" width="100" sortable>
			</el-table-column>
			<el-table-column prop="userNameEn" label="英文名称" width="120"  sortable>
			</el-table-column>
			<el-table-column prop="roleTypeName" label="用户类型" width="100" sortable>
			</el-table-column>
			<el-table-column prop="cityName" label="城市" width="100" sortable>
			</el-table-column>
			<el-table-column prop="businessGroupNames" label="所属业务组" width="100" sortable>
			</el-table-column>
			<el-table-column prop="projectNames" label="管理项目" width="100" sortable>
				<template slot-scope="scope">
                  <span v-if="scope.row.roleType == 1 "></span>
				  <span v-else>{{scope.row.projectNames}}</span>
	              </template>
			</el-table-column>
			<el-table-column prop="userPosition" label="职位" width="120" sortable>
			</el-table-column>
			<el-table-column prop="roleName" label="用户权限" min-width="90" sortable>
			</el-table-column>
			<el-table-column prop="account" label="邮箱" min-width="100" sortable>
			</el-table-column>
			<el-table-column prop="mobilePhone" label="移动电话号" min-width="100" sortable>
				<template slot-scope="scope">
                  <span v-if="scope.row.mobilePrefix ">{{scope.row.mobilePrefix}}-{{scope.row.mobilePhone}}</span>
				  <span v-else>{{scope.row.mobilePhone}}</span>
	              </template>
			</el-table-column>
			<el-table-column prop="acceptTimeStr" label="隐私协议确认" min-width="120" sortable>
			</el-table-column>
			<el-table-column prop="acceptAgreementVersion" label="隐私协议版本" min-width="120" sortable>
			</el-table-column>
			<el-table-column label="操作" width="200">
				<template scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">修改</el-button>
					<el-button size="small" @click="handlePasswordReset(scope.$index, scope.row)">密码重置</el-button>
					<el-button size="small" @click="handleDeleteOne(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-dialog title="管理员确认"  v-model="resetPswDialogVisible" @close="cancelResetPswSubmit">
			<el-form :model="resetPswForm" :rules="resetPswFormRules" ref="resetPswForm">
				<el-form-item label="管理员密码" prop="adminPwd" label-width="100px">
					<el-input type="password" v-model="resetPswForm.adminPwd" auto-complete="off"></el-input>
				</el-form-item>
				
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelResetPswSubmit">取 消</el-button>
				<el-button v-bind:disabled="resetPswButtonDisabled" type="primary" @click="resetPswFormOnSubmit">确 定</el-button>
			</div>
        </el-dialog>
		
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="15" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--编辑界面-->
		<el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="120px" :rules="editFormRules" ref="editForm">
				<el-form-item label="用户类型" prop="roleType">
					<el-radio-group v-model="editForm.roleType" :change="handleRoleTypeChange('edit',addForm.roleType)">
						<el-radio class="radio" :label="0">JLL用户</el-radio>
						<el-radio class="radio" :label="1">客户</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="中文姓名" prop="userNameCn">
					<el-input v-model="editForm.userNameCn" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="英文姓名" prop="userNameEn">
					<el-input v-model="editForm.userNameEn" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="中英文显示" prop="nameModel">
					<el-radio-group v-model="editForm.nameModel" >
						<el-radio class="radio" :label="0">中文</el-radio>
						<el-radio class="radio" :label="1">英文</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="移动电话号" prop="mobilePhone">
					<el-select style="width: 80px;dispaly:inline;"  v-model="editForm.mobilePrefix">
						<el-option v-for="i in mobilePrefixList" :label="i.name" :value="i.code"></el-option>
					</el-select>
					<span>-</span>
					<el-input  style="width: 380px;dispaly:inline;" v-model="editForm.mobilePhone" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="邮箱" prop="email">
					<el-input v-model="editForm.email" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item  v-if="editForm.roleType == 1" style="width: 240px" label="账户有效期" prop="expirationTime">
					<el-date-picker style="width: 240px"  v-model="editForm.expirationTime" @change="handleEditFormExpirationTime" type="date" placeholder="请选择" ></el-date-picker>
				</el-form-item>
				<el-form-item v-if="editForm.roleType == 1"  label="担保用户">
					<!-- <el-select @change="handleGetRelationProjectList(editForm.warrantAccount)"  style="width: 240px"  v-model="editForm.warrantAccount">
						<el-option v-for="i in warrantAcountList" :label="i.code" :value="i.id"></el-option>
					</el-select> -->
					<el-select   style="width: 240px" @change="handleGetRelationProjectList('edit',editForm.warrantAccount)" filterable remote reserve-keyword :remote-method="getWarrantAcountList" placeholder="请输入用户名搜索" v-model="editForm.warrantAccount">
						<el-option v-for="i in warrantAcountList" :key="i.id" :label="i.name" :value="i.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="editForm.roleType == 1" prop="projectIds" label="关联项目">
					<div >
					   <treeselect  :options ="relationProjectList" :load-root-options="loadRootOptions"  :treeMark="treeMark" :auto-load-root-options="false" :multiple="true" 
                          style="width:240px;" placeholder="请选择" noOptionsText="暂无可关联的项目" v-model="editForm.projectIds" />
					</div>
				</el-form-item>
				<el-form-item v-if="editForm.roleType == '0'" label="职位" prop="userPosition">
					<el-input v-model="editForm.userPosition" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item v-if="editForm.roleType == '0'" label="城市"  prop="city">
					<!-- <el-input style="width: 240px" v-model="editForm.city" auto-complete="off"></el-input> -->
					<el-select   style="width: 240px" filterable remote reserve-keyword :remote-method="getRegionAreaList" placeholder="请输入城市名称搜索" v-model="editForm.city">
						<el-option v-for="i in regionAreaList" :label="i.name" :value="i.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="editForm.roleType == '0'" label="用户权限"  prop="roleIdentity">
					<el-select  style="width: 140px" v-model="editForm.roleIdentity">
						<el-option v-for="i in accountRoleList" :label="i.roleName" :value="i.identity"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="editForm.roleIdentity == 'level-one' && editForm.roleType == '0'" label="大区"  prop="regionCode">
					<el-select  style="width: 240px" v-model="editForm.regionCode">
						<el-option v-for="i in regionList" :label="i.name" :value="i.code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="editForm.roleIdentity == 'level-three' && editForm.roleType == '0'"  label="项目权限"  prop="projectIdArray">
					<div >
					<treeselect :multiple="true" :options="projectTree"  style="width:240px;" :disable-branch-nodes="true"  v-model="editForm.projectIdArray" />
					</div>
				</el-form-item>
				<el-form-item v-if="editForm.roleIdentity == 'level-two' && editForm.roleType == '0'" label="业务组权限"  prop="businessGroupIds">
					<el-select  style="width:140px" v-model="businessGroupIdsSelect" @change="handleSelect" :placeholder="editForm.businessGroupNames"> 
						<el-option v-for="i in bussiessGroupBriefList" :label="i.name" :value="i.id"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" v-bind:disabled="editSubmitButtonDisabled" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--新增界面-->
		<el-dialog title="添加新用户" v-model="addFormVisible"  :close-on-click-modal="false" @close="cancelAddSubmit">
			<el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm">
				<el-form-item label="用户类型" prop="roleType">
					<el-radio-group v-model="addForm.roleType" :change="handleRoleTypeChange('add',addForm.roleType)">
						<el-radio class="radio" :label="0">JLL用户</el-radio>
						<el-radio class="radio" :label="1">客户</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="中文姓名" prop="userNameCn">
					<el-input v-model="addForm.userNameCn" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="英文姓名" prop="userNameEn">
					<el-input v-model="addForm.userNameEn" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="中英文显示" prop="nameModel">
					<el-radio-group v-model="addForm.nameModel" >
						<el-radio class="radio" :label="0">中文</el-radio>
						<el-radio class="radio" :label="1">英文</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="移动电话号" prop="mobilePhone">
					<el-select style="width: 80px;dispaly:inline;"  v-model="addForm.mobilePrefix">
						<el-option v-for="i in mobilePrefixList" :label="i.name" :value="i.code"></el-option>
					</el-select>
					<span>-</span>
					<el-input  style="width: 380px;dispaly:inline;" v-model="addForm.mobilePhone" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="邮箱" prop="email">
					<el-input v-model="addForm.email" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item  v-if="addForm.roleType == 1" style="width: 240px" label="账户有效期" prop="expirationTime">
					<el-date-picker style="width: 240px"  v-model="addForm.expirationTime" @change="handleAddFormExpirationTime" type="date" placeholder="请选择" ></el-date-picker>
				</el-form-item>
				<el-form-item v-if="addForm.roleType == 1" prop="warrantAccount" label="担保用户">
					<!-- <el-select @change="handleGetRelationProjectList(addForm.warrantAccount)"  style="width: 240px"  v-model="addForm.warrantAccount">
						<el-option v-for="i in warrantAcountList" :label="i.code" :value="i.id"></el-option>
					</el-select> -->
					<el-select   style="width: 240px" @change="handleGetRelationProjectList('add',addForm.warrantAccount)" filterable remote reserve-keyword :remote-method="getWarrantAcountList" placeholder="请输入用户名搜索" v-model="addForm.warrantAccount">
						<el-option v-for="i in warrantAcountList" :key="i.id" :label="i.name" :value="i.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="addForm.roleType == 1" prop="projectIds" label="关联项目">
					<div >
					   <treeselect :load-root-options="loadRootOptions"  :treeMark="treeMark" :auto-load-root-options="false" :multiple="true" 
                          style="width:240px;" placeholder="请选择" noOptionsText="暂无可关联的项目" v-model="addForm.projectIds" />
					</div>
				</el-form-item>
				<el-form-item v-if="addForm.roleType == '0'" label="职位" prop="userPosition">
					<el-input v-model="addForm.userPosition" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item v-if="addForm.roleType == '0'" label="城市"  prop="city">
					<!-- <el-input style="width: 240px" v-model="addForm.city" auto-complete="off"></el-input> -->
					<el-select   style="width: 240px" filterable remote reserve-keyword :remote-method="getRegionAreaList" placeholder="请输入城市名称搜索" v-model="addForm.city">
						<el-option v-for="i in regionAreaList" :label="i.name" :value="i.id"></el-option>
					</el-select>
					<!-- <treeselect :load-options="loadOptions" :async="true"  
                          style="width:240px;"  noOptionsText="暂无数据" v-model="addForm.city" /> -->
				</el-form-item>
				<el-form-item v-if="addForm.roleType == '0'" label="用户权限"  prop="roleIdentity">
					<el-select  style="width: 240px" v-model="addForm.roleIdentity">
						<el-option v-for="i in accountRoleList" :label="i.roleName" :value="i.identity"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="addForm.roleIdentity == 'level-one' && addForm.roleType == '0'" label="大区"  prop="regionCode">
					<el-select  style="width: 240px" v-model="addForm.regionCode">
						<el-option v-for="i in regionList" :label="i.name" :value="i.code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item  v-if="addForm.roleIdentity == 'level-three' && addForm.roleType == '0'"  label="项目权限"  prop="projectIdArray">
					<div >
					<treeselect :multiple="true" :options="projectTree" :disable-branch-nodes="true" style="width:240px;" placeholder="请选择项目" v-model="addForm.projectIdArray" />
					</div>
				</el-form-item>
				<el-form-item v-if="addForm.roleIdentity == 'level-two' && addForm.roleType == '0'" label="业务组权限"  prop="businessGroupIds">
					<el-select  style="width:140px" v-model="addForm.businessGroupIds"> 
						<el-option v-for="i in bussiessGroupBriefList" :label="i.name" :value="i.id"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancelAddSubmit">取消</el-button>
				<el-button type="primary" v-bind:disabled="addSubmitButtonDisabled" @click.native="addSubmit" :loading="addLoading" >提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	import api from '@/api';
	import tools from '@/util/tools';
	import Treeselect from '@riophae/vue-treeselect'
    import { ASYNC_SEARCH } from '@riophae/vue-treeselect'
	import global from '@/config/global_config'
	import Vue from 'vue'
	import router from '@/router/index.js'

	export default {
		components: { Treeselect },
		data() {
			return {
				filters: {
					name: ''
				},
				list_data: [],
				total: 0,
				page: 1,
				value:[],
				listLoading: false,
				sels: [],
				search_word:'',
				accountRoleList:[],
				bussiessGroupBriefList:[],
				editFormVisible: false,
				editLoading: false,
				editFormRules: {
					userNameCn: [
						{ required: true, message: '中文名称不能为空', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					],
					userNameEn: [
						{ required: true, message: '英文姓名不能为空', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					],
					nameModel: [
						{ type:'number', required: true, message: '中英文显示不能为空', trigger: 'blur' }
					],
					mobilePhone: [
						{ required: true, message: '移动电话号不能为空', trigger: 'blur' },
						{ pattern: /^1[3456789]\d{9}$/ ,message: '手机格式不合法',trigger: 'blur'}
					],
					email: [
						{ required: true, message: '邮箱不能为空', trigger: 'blur' },
						{ pattern: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/ ,message: '邮件格式不合法',trigger: 'blur'},
						{ min: 1, max: 80, message: '输入长度在1到80个字符之间',trigger: 'blur'}
					],
					userPosition: [
						//{ required: true, message: '职位不能为空', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					],
					roleIdentity: [
						{ required: true, message: '请选择用户权限', trigger: 'blur' }
					],
					expirationTime: [
						// { required: true, message: '请选择账号过期时间', trigger: 'blur' }
					],
					warrantAccount: [
						{ required: true, message: '请选择担保用户' }
					],
					regionCode: [
						{ required: true, message: '请选择所属大区',trigger: 'blur' }
					],
				},
				editForm: {

				},
				addFormVisible: false,
				addLoading: false,
				addFormRules: {
					roleType: [
						{ type:'number', required: true, message: '用户类型不能为空', trigger: 'blur' }
					],
					userNameCn: [
						{ required: true, message: '中文名称不能为空', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					],
					userNameEn: [
						{ required: true, message: '英文姓名不能为空', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					],
					nameModel: [
						{ type:'number', required: true, message: '中英文显示不能为空', trigger: 'blur' }
					],
					mobilePhone: [
						{ required: true, message: '移动电话号不能为空',trigger: 'blur'},
						{ pattern: /^1[3456789]\d{9}$/ ,message: '手机格式不合法',trigger: 'blur'}
					],
					email: [
						{ required: true, message: '邮箱不能为空', trigger: 'blur' },
						{ pattern: /^[a-zA-Z0-9]+([._\\-]*[a-zA-Z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/ ,message: '邮件格式不合法',trigger: 'blur'},
						{ min: 1, max: 80, message: '输入长度在1到80个字符之间',trigger: 'blur'}
					],
					userPosition: [
						//{ required: true, message: '职位不能为空', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					],
					roleIdentity: [
						{ required: true, message: '请选择用户权限', trigger: 'blur' }
					],
					expirationTime: [
						// { required: true, message: '请选择账号过期时间', trigger: 'blur' }
					],
					warrantAccount: [
						{ required: true, message: '请选择担保用户' }
					],
					regionCode: [
						{ required: true, message: '请选择所属大区',trigger: 'blur' }
					],
				},
				addForm: {
					roleType:0,
					nameModel:0
				},
				projectTree:[],
				bussiessGroupIdsList:[],
				businessGroupIdsSelect:'',
				batchImportDialogVisible:false,
				uploadUrl:global.apiBaseURL+'/accounts/upload',
				uploadHeader:{access_token:global.getAccessToken()},
				resetPswDialogVisible:false,
				resetPswFormRules: {
					adminPwd: [
						{ required: true, message: '请输入密码', trigger: 'blur' },
					]
				},
				resetPswForm: {adminPwd:'',account:''},
				editSubmitButtonDisabled:false,
				addSubmitButtonDisabled:false,
				resetPswButtonDisabled:false,
				regionList:[],
				cityList:[],
				shortAcountList:[],
				shortAcountList_tree:[],
				relationProjectList:null,
				treeMark:"one",
				mobilePrefixList:[{name:"+86",code:"+86"},{name:"+1",code:"+1"},{name:"+44",code:"+44"},{name:"+852",code:"+852"},{name:"+853",code:"+853"},
				{name:"+886",code:"+886"},{name:"+61",code:"+61"}],
				regionAreaList:[],
				expirationTime :"",
				warrantAcountList:[],
				warrantAccount:""
			}
		},
		methods: {
			handleCurrentChange(val) {
				if(val == null || val == '') return;
				this.page = val;
				this.get_list_data();
			},
			handleSearch(){
				this.get_list_data();
			},
			handleSelect(index){
				this.editForm.businessGroupIds = this.businessGroupIdsSelect;
			},
			handleAddFormExpirationTime(val){
				if(val == null || val == '') return;
				let split_tmp = val.split('-');
				this.expirationTime = split_tmp[0]+split_tmp[1]+split_tmp[2];
			},
			handleEditFormExpirationTime(val){
				if(val == null || val == '') return;
				let split_tmp = val.split('-');
				this.expirationTime = split_tmp[0]+split_tmp[1]+split_tmp[2];
			},
			handleGetRelationProjectList(type,val){
				if(val == null || val == '') return;
				if(type == 'edit'){
					if(this.warrantAccount == val)return;
				    else this.warrantAccount = val;
				}
				console.log(val);
				this.treeMark = "two"
				this.addForm.projectIds = [];
				this.editForm.projectIds = [];
				let param = {accountId:val};
				this.listLoading = true;
				api.project_findProjectListByAccountId_request(param).then((res) => {
					let temp = [];
					if(res.data){
						let index = 0
						for (let i = 0; i < res.data.length; i++) {
							res.data[i].projectList.forEach(one => {
								temp[index] = {id:parseInt(one.projectId),label:one.projectName};
								index++;
							});
						}
					}
					this.relationProjectList = temp;
				}).catch(function (e) {
					console.log(e);
                });
				this.listLoading = false;
			},
			handleRoleTypeChange(type,val){
				if(null != val && val == 0){
					if(type == 'edit'){
						if(this.editForm.roleIdentity == 'level-four'){
							this.editForm.roleIdentity = '';
						}
					}
					else{

					}
				}
				return;
			},
		    loadRootOptions(callback) {
				setTimeout(() => callback(null, this.relationProjectList), 1000)
			},
			loadOptions({ action, searchQuery, callback }) {
				console.log(searchQuery);
				if (action === ASYNC_SEARCH) {
					console.log(searchQuery);
					api.account_getRegionAreaList_request(param).then((res) => {
						let temp = [];
						if(res.data){
							for (let i = 0; i < res.data.length; i++) {
								temp[i] = {id:parseInt(one.id),label:one.name};
							}
							this.regionAreaList = temp;
							callback(null, this.regionAreaList)
						}
					}).catch(function (e) {
						console.log(e);
					});
					// simulateAsyncOperation(() => {
					// const options = [ 1, 2, 3, 4, 5 ].map(i => ({
					// 	id: `${searchQuery}-${i}`,
					// 	label: `${searchQuery}-${i}`,
					// }))
					// callback(null, options)
					// })
				}
            },
			get_list_data() {
				let param = {
					keys:this.search_word,
					pageNum: this.page,
					pageSize: 15
				};
				this.listLoading = true;
				api.account_list_request(param).then((res) => {
					this.total = res.data.total;
					res.data.list.forEach(one => {
						if(one.roleType == "0")one.roleTypeName = "JLL用户"
						else if(one.roleType == "1")one.roleTypeName = "客户"
					})
					this.list_data = res.data.list;
					this.listLoading = false;
				}).catch((e) => {
					console.log(e);
					tools.error(new Vue(),e.message);
				});
			},
			handleDeleteOne: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {showClose:false}).then(() => {
					let param = { ids: row.id };
					api.account_remove_request(param).then(
						res => {
							tools.success(this,"删除成功");
							this.get_list_data();
						}
					).catch((e) => {
						console.log(e);
						if(e.message)tools.error(new Vue(),e.message);
				    });
				})
			},
			handlePasswordReset:function (index, row) {
				this.resetPswDialogVisible = true;
				this.resetPswForm.account = row.account;
			},
			resetPswFormOnSubmit: function () {
				this.$refs.resetPswForm.validate((valid) => {
					if (valid) {
						this.resetPswButtonDisabled=true;
						let param = this.resetPswForm;
						this.listLoading = true;
						let self = this;
						api.account_resetPwd_request(param).then((res) => {
							this.resetPswButtonDisabled=false;
							this.listLoading = false;
							this.resetPswDialogVisible = false;
							this.$refs.resetPswForm.resetFields();
							tools.success(this,"重置成功");
						}).catch(function (e) {
							console.log(e);
							tools.error(new Vue(),e.message);
							self.resetPswButtonDisabled=false;
						});
						this.listLoading = false;
					}
				})
			},
			handleEdit: function (index, row) {
				if(row.roleType == 1){
					this.warrantAccount = row.warrantAccount;
					let param = {accountId:row.warrantAccount};
					this.listLoading = true;
					api.project_findProjectListByAccountId_request(param).then((res) => {
						let temp = [];
						if(res.data){
							let index = 0
							for (let i = 0; i < res.data.length; i++) {
								res.data[i].projectList.forEach(one => {
									temp[index] = {id:parseInt(one.projectId),label:one.projectName};
									index++;
								});
							}
							this.relationProjectList = temp;
							row.projectIds = '';
							row.projectIdArray = '';
							if(row.warrantAccount){
								this.warrantAcountList=[{id:row.warrantAccount,name:row.warrantAccountName}]
							}
							this.editForm = Object.assign({}, row);
							delete this.editForm['account'];
							if(row.businessGroupNameIds) this.editForm.businessGroupIds = row.businessGroupNameIds.split(':')[1];
							this.editForm.email = row.account;
							this.editForm.nameModel = parseInt(this.editForm.nameModel); 
							this.editForm.projectIds = [];
							this.editForm.projectIdArray = [];
							if(row.projectNameIds){
								let projectIds = [];
									let split = row.projectNameIds.split('|');
									split.forEach(one => {
										let split_tmp = one.split(':');
										projectIds.push(parseInt(split_tmp[1]));
									});
									this.editForm.projectIds = projectIds;
							}
							this.regionAreaList=[{id:row.city,name:row.cityName}]
							this.editForm.roleType = parseInt(this.editForm.roleType);
							if(row.expirationTime && row.expirationTime.length == 8){
								let year = row.expirationTime.substr(0,4);
								let month = row.expirationTime.substr(4,2);
								let date = row.expirationTime.substr(6,2);
								this.expirationTime = year+""+month+""+date;
								this.editForm.expirationTime = year+"-"+month+"-"+date;
							}
							else{
								this.expirationTime = "";
								this.editForm.expirationTime = "";
							}
							if(!this.editForm.mobilePrefix) this.editForm.mobilePrefix = "+86"
							console.log(this.editForm);
							this.editFormVisible = true;
							// api.project_getProjectAcountAble_request({}).then((res) => {
							// 	if(res.data){
							// 		this.shortAcountList_tree = res.data;
							// 		this.shortAcountList = res.data;
							// 	}
							// }).catch((e) => {
							// 	console.log(e);
							// });
							this.listLoading = false;
						}
					}).catch(function (e) {
						console.log(e);
						this.listLoading = false;
					});
				}
				else{
					let param = {};
					this.listLoading = true;
					api.project_getProjectAcountAble_request(param).then((res) => {
						this.shortAcountList_tree = res.data;
						this.shortAcountList = res.data;
						this.editFormVisible = true;
						row.projectIds = '';
						row.projectIdArray = '';
						this.editForm = Object.assign({}, row);
						// if(this.editForm.warrantAccount)this.editForm.warrantAccount = parseInt(this.editForm.warrantAccount);
						delete this.editForm['account'];
						if(row.businessGroupNameIds) this.editForm.businessGroupIds = row.businessGroupNameIds.split(':')[1];
						this.editForm.email = row.account;
						this.editForm.nameModel = parseInt(this.editForm.nameModel); 
						this.editForm.projectIds = [];
						this.editForm.projectIdArray = [];
						this.editForm.warrantAccount = '';
						this.editForm.warrantAccountName = '';
						this.editForm.expirationTime = "";
						if(row.projectNameIds){
							let projectIdArray = [];
							let split = row.projectNameIds.split('|');
							split.forEach(one => {
								let split_tmp = one.split(':');
								projectIdArray.push(parseInt(split_tmp[1]));
							});
							this.editForm.projectIdArray = projectIdArray;
						}
						this.regionAreaList=[{id:row.city,name:row.cityName}]
						this.editForm.roleType = parseInt(this.editForm.roleType); 
						if(!this.editForm.mobilePrefix) this.editForm.mobilePrefix = "+86"
						console.log(this.editForm);
					}).catch((e) => {
						console.log(e);
					});
					this.listLoading = false;
				}

				},
				handleAdd: function () {
					let param = {};
					this.listLoading = true;
					api.project_getProjectAcountAble_request(param).then((res) => {
						// let temp = [];
						// console.log(res.data);
						// for (let index = 0; index < res.data.length; index++) {
						// 	temp[index] = {id:res.data[index].id ,label:res.data[index].code};
						// }
						this.shortAcountList_tree = res.data;
						this.shortAcountList = res.data;
						this.addFormVisible = true;
						this.addForm = {
							roleType:0,
							nameModel:0,
							mobilePrefix:"+86"
						};
					}).catch((e) => {
						console.log(e);
					});
					this.listLoading = false;
			},
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.editSubmitButtonDisabled=true;
						delete this.editForm['businessGroupNameIds'];
						delete this.editForm['businessGroupNames'];
						delete this.editForm['roleName'];
						delete this.editForm['projectNames'];
						delete this.editForm['projectNameIds'];
						let param = Object.assign({}, this.editForm);
						param.projectIds = this.editForm.projectIds;
						param.projectIdArray = this.editForm.projectIdArray;
						console.log(param);
						if(param.roleType == 1){
							param.expirationTime = this.expirationTime;
							param.roleIdentity = 'level-four';
							param.projectIdArray = "";
							if(param.projectIds ){
								console.log(param.projectIds);
								let temp = [];
								param.projectIds.forEach(one => { 
									temp.push(one);
								});
								if(temp.length>=1)param.projectIds = temp.join(',');
								else param.projectIds = '';
								console.log(temp);
							}
							else {
								param.projectIds ='';
							}
						}
						else{
							param.projectIds = "";
							if(param.projectIdArray && param.roleIdentity == 'level-three'){
							console.log(param.projectIdArray);
							let temp = [];
							param.projectIdArray.forEach(one => { 
								temp.push(one);
							});
							if(temp.length>=1)param.projectIdArray = temp.join(',');
							else param.projectIdArray = '';
							console.log(temp);
							param.businessGroupIds = '';
							}
							else if(param.roleIdentity == 'level-two'){
								param.projectIdArray ='';
							}
							else {
								param.projectIdArray ='';
								param.businessGroupIds = '';
							}
							param.expirationTime ='';
						}
						console.log(param);
						this.listLoading = true;
						let self = this;
						api.account_update_request(param).then((res) => {
							this.editFormVisible = false;
							// console.log(this.$refs.editForm.fields);
							// this.$refs.editForm.fields.forEach(function (field,index) {
							// 	if(field.prop == undefined)delete this.$refs.editForm.fields[index];
							// });
							for (let index = 0; index < this.$refs.editForm.fields.length; index++) {
								if(this.$refs.editForm.fields[index].prop == undefined)delete this.$refs.editForm.fields[index];
						    }
							this.$refs.editForm.resetFields();
							this.editSubmitButtonDisabled=false;
							this.expirationTime = "";
							tools.success(this,"编辑成功");
							this.get_list_data();
						}).catch(function (e) {
							console.log(e);
							tools.error(new Vue(),e.message);
							self.editSubmitButtonDisabled=false;
					    });	
						this.listLoading = false;
					}
				});
			},
			addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						this.addSubmitButtonDisabled=true;
						let param = Object.assign({}, this.addForm);
						if(param.roleType == 1){
							param.expirationTime = this.expirationTime;
							if(param.projectIds){
								let temp = [];
								param.projectIds.forEach(one => {
									temp.push(one);
								});
								if(temp.length>=1)param.projectIds = temp.join(',');
								else param.projectIds = '';
						    }
						}
						else{
							if(param.projectIdArray){
								let temp = [];
								param.projectIdArray.forEach(one => {
									temp.push(one);
								});
								if(temp.length>=1)param.projectIdArray = temp.join(',');
								else param.projectIdArray = '';
						    }
						}
						console.log(param);
						this.listLoading = true;
						let self = this;
						api.account_add_request(param).then((res) => {
							this.addFormVisible = false;
							this.$refs.addForm.resetFields();
							this.addSubmitButtonDisabled=false;
							this.expirationTime = "";
							tools.success(this,"新增成功");
							this.get_list_data();
                        }).catch(function (e) {
							console.log(e);
							tools.error(new Vue(),e.message);
							self.addSubmitButtonDisabled=false;
					    });	
						this.listLoading = false;
					}
				});
			},
			fetchAccountRoleList: function () {
				let param = {};
				this.listLoading = true;
				api.account_getAccountRoleList_request(param).then((res) => {
					this.accountRoleList = res.data;	
				}).catch((e) => {
					console.log(e);
				});
				this.listLoading = false;
			},
			handleBatchImport:function () {
				this.batchImportDialogVisible = true;
			},
			downloadTemplate(){
				let param = {};
				api.accounts_getImportTemplate_request(param).then((res) => {
					let blob = new Blob([res.data],{type:'application/vnd.ms-excel'});
					let fileLink = document.createElement('a')
					fileLink.href = window.URL.createObjectURL(blob);
					fileLink.download =  'template_user'+'_' + new Date().getTime() + '.xls'
					fileLink.click();
				}).catch(function (e) {
					console.log(e);
					tools.error(new Vue(),e.message);
				});
			},
			handleUploadExceed(files, fileList){
				tools.error(this,'每次只能上传一个文件!');
				return false
			},
			handleBeforeUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 20;
				if (!isLt2M) {
					tools.error(this,'文件过大,注意不能超过20MB!');
					return false
				}
				let Xls = file.name.split('.');
                if(Xls[1] === 'xls'||Xls[1] === 'xlsx'){
                    return file
                }else {
                    tools.error(this,'上传文件只能是 xls/xlsx 格式!')
                    return false
				}
			},
			batchImportOnSubmit(){
				this.$refs.batchImportUpload.submit();
			},
			cancelUpload(){
				this.batchImportDialogVisible = false;
				this.$refs.batchImportUpload.clearFiles();
			},
			handleUploadSuccess(res,file,fileList){
				if(res.code == 200) {
					tools.success(this,"上传成功");
					this.batchImportDialogVisible = false;
					this.$refs.batchImportUpload.clearFiles();
					this.get_list_data();
				}
                else {
					if(res.code == 402) {
						sessionStorage.removeItem('user');
						sessionStorage.removeItem('localRoutes');
						tools.error(new Vue(),'会话已过期,请重新登录');
						router.push('/login');
						location.reload();
					}
					else{
						let errorMessage = '';
						if(res.errorMap){
							Object.keys(res.errorMap).forEach(key => {
								errorMessage += key+"字段:"+res.errorMap[key]+','
							});
							errorMessage = res.msg + '(详细原因：'+ errorMessage +')';
						}
						else errorMessage = res.msg;
						tools.error(new Vue(),errorMessage);
				    }
				}
			},
			handleUploadError(){
				tools.error(this,res.data.msg);
			},
			handleDataExport:function () {

			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			exportData:function () {
				let param = {
					keys:this.search_word,
				};
				this.listLoading = true;
				api.account_exportData_request(param).then((res) => {
					let blob = new Blob([res.data],{type:'application/vnd.ms-excel'});
					let fileLink = document.createElement('a')
					fileLink.href = window.URL.createObjectURL(blob);
					fileLink.download =  'userList'+'_' + new Date().getTime() + '.xls'
					fileLink.click();
				}).catch(function (e) {
					console.log(e);
					tools.error(new Vue(),e.message);
				});
				this.listLoading = false;
			},
			getBussiessGroupbriefList: function () {
				let param = {};
				this.listLoading = true;
				api.bussiessGroupBriefList_request(param).then((res) => {
					if(res.data){
						res.data.forEach(one => {
							this.bussiessGroupIdsList.push(one.id);
						})
						this.bussiessGroupBriefList = res.data;	
					}
				}).catch(function (e) {
					console.log(e);
				});
				this.listLoading = false;
			},
			getProjectTree: function () {
				let param = {};
				this.listLoading = true;
				api.project_findByAccountIdList_request(param).then((res) => {
					let temp = [];
					if(res.data){
						for (let index = 0; index < res.data.length; index++) {
							temp[index] = {id:-res.data[index].groupId ,label:res.data[index].groupName,children:[]};
							res.data[index].projectList.forEach(one => {
								temp[index].children.push({id:parseInt(one.projectId),label:one.projectName});
							});
						}
					    console.log(temp);
					}
					this.projectTree = temp;
				}).catch(function (e) {
					console.log(e);
                });
				this.listLoading = false;
			},
			cancelAddSubmit(){
				this.addFormVisible = false;
				this.$refs.addForm.resetFields();
				if(this.addSubmitButtonDisabled)this.addSubmitButtonDisabled = false;
			},
			cancelResetPswSubmit(){
				this.resetPswDialogVisible = false
				this.$refs.resetPswForm.resetFields();
				if(this.resetPswButtonDisabled)this.resetPswButtonDisabled = false;
			},
			getRegionList: function () {
				let param = {};
				api.getRegionList(param).then((res) => {
					let temp = [];
					if(res.data){
						this.regionList = res.data;
					}
				}).catch(function (e) {
					console.log(e);
				});
			},
			getRegionAreaList: function (query) {
				console.log(query)
				let param = {keys:query};
				api.account_getRegionAreaList_request(param).then((res) => {
					if(res.data){
						this.regionAreaList = res.data;
					}
				}).catch(function (e) {
					console.log(e);
				});
			},
			getWarrantAcountList:function (keys) {
				let param = {keys:keys};
				api.account_getWarrantAcountList_request(param).then((res) => {
					if(res.data){
						this.warrantAcountList = res.data;
					}
				}).catch(function (e) {
					console.log(e);
				});
			}
		},
		mounted() {
			this.get_list_data();
			this.fetchAccountRoleList();
			this.getBussiessGroupbriefList();
			this.getProjectTree();
			this.getRegionList();
			//this.getRegionAreaList();
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// user_list.vue?cb32eab8